export default __webpack_public_path__ + "static/media/037-packing.bb70f584.png";